// extracted by mini-css-extract-plugin
export var alignCenter = "_aa-d";
export var bannerShown = "_aa-6";
export var buttonContent = "_aa-0";
export var cardList = "_aa-1";
export var centerContent = "_aa-2";
export var chevron = "_aa-3";
export var closePanelButton = "_aa-k";
export var conversationContextContainer = "_aa-l";
export var conversationDetailContainer = "_aa-4";
export var detailWrapper = "_aa-7";
export var dropdownButton = "_aa-e";
export var dropdownTitle = "_aa-9";
export var fullHeight = "_aa-5";
export var hidden = "_aa-a";
export var icon = "_aa-b";
export var mergeSuggestionWrapper = "_aa-m";
export var panel = "_aa-i";
export var portalButtonsWrapper = "_aa-c";
export var right = "_aa-j";
export var tableSummaryContainer = "_aa-8";
export var tableSummaryHeader = "_aa-g";
export var threeDotsButton = "_aa-f";
export var wide = "_aa-h";